import { useSelector, useDispatch } from "react-redux";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

import messages from "../../../assets/locale/messages";
import Button from "../../../components/Button";
import Checkbox from "../../../components/Checkbox";
import { editServiceRequest } from "../../../store/Services/actions";
import { renderTextEllipsis } from "../../../utils/Helpers";

const LookupsRequestsCard = ({
  requestData,
  isBulkSelection,
  selectedCards,
  setSelectedCards,
  setSelectedSingleCard,
  setShowRejectRequestModal,
  onsuccess,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const isEnglish = lang === "en";
  const { lookupsRequests } = messages[lang];
  const dispatch = useDispatch();
  const handleCheckCard = (isChecked, id) => {
    if (isChecked) {
      setSelectedCards([...selectedCards, id]);
    } else {
      const updatedSelectedCartds = selectedCards.filter((item) => item !== id);
      setSelectedCards(updatedSelectedCartds);
    }
  };

  const handleRejectSingleCard = () => {
    setShowRejectRequestModal(true);
    setSelectedSingleCard(requestData);
  };

  const handleAcceptSingleCard = () => {
    dispatch(
      editServiceRequest(
        {
          id: +requestData.id,
          data: {
            status: "accepted",
          },
        },
        () => {
          onsuccess();
        }
      )
    );
    setSelectedSingleCard(null);
  };

  return (
    <div className="bg-white rounded-4 p-4 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        {isBulkSelection ? (
          <Checkbox
            color="secondary"
            checkboxClass="mb-2"
            label={
              <div className="fsize-20 fweight-700 font-reguler text-break">
                {renderTextEllipsis(
                  requestData?.[isEnglish ? "title_en" : "title_ar"],
                  40
                )}
              </div>
            }
            checked={!!selectedCards.find((item) => item === requestData?.id)}
            name={requestData?.[isEnglish ? "title_en" : "title_ar"]}
            id={requestData?.[isEnglish ? "title_en" : "title_ar"]}
            onChange={(elementIsChecked, e) =>
              handleCheckCard(elementIsChecked, requestData?.id)
            }
          />
        ) : (
          <div className="fsize-20 fweight-700 mb-2 text-break">
            {renderTextEllipsis(
              requestData?.[isEnglish ? "title_en" : "title_ar"],
              40
            )}
          </div>
        )}
        {requestData?.service_type === "multi_session" && (
          <span className="align-self-start align-self-md-center rounded-4 bg-secondary px-3 text-white fsize-12">
            {lookupsRequests.card.multiSessionsTag}
          </span>
        )}
      </div>
      <div className="fsize-16 fweight-400">
        <div className="mb-2 d-flex flex-column flex-md-row gap-md-4 gap-1 align-items-md-center">
          <div className="d-flex gap-1 text-break">
            <span className="text-secondary">
              <BusinessCenterOutlinedIcon />
            </span>
            {renderTextEllipsis(
              requestData?.specialty?.[isEnglish ? "title_en" : "title_ar"],
              40
            )}
          </div>
          <div className="d-flex gap-2 align-items-center">
            <span className="align-self-start align-self-md-center rounded-4 bg-secondary px-3 text-white fsize-12">
              {requestData?.specialty?.creator_type === "ServiceProvider"
                ? lookupsRequests.list.addedByProvider
                : null}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column flex-lg-row justify-content-between">
          <div className="mb-2 d-flex gap-1 text-break">
            <span className="text-secondary">
              <PersonOutlineOutlinedIcon />
            </span>
            {renderTextEllipsis(
              requestData?.[isEnglish ? "creator_name_en" : "creator_name_ar"] || requestData?.creator_name,
              40
            )}
          </div>
          {!isBulkSelection && (
            <div className="d-flex justify-content-end gap-2">
              <Button
                onClick={handleRejectSingleCard}
                outlined
                label={lookupsRequests.card.rejectLabel}
                btnStyle="secondary"
                labelClass="fsize-15 fweight-400 text-secondary px-5"
              />
              <Button
                onClick={handleAcceptSingleCard}
                label={lookupsRequests.card.acceptLabel}
                btnStyle="secondary"
                labelClass="fsize-15 fweight-400 text-white px-5"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LookupsRequestsCard;
